{
  "CREATE_SEARCH_MODAL_TITLE": {
    "text": "Lagre søk",
    "crowdinContext": "Create saved search modal header title"
  },
  "CREATE_MODAL_NAME_INPUT_LABEL": {
    "text": "Navn",
    "crowdinContext": "Label of the name edit input for create modal"
  },
  "CREATE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Lagre søket",
    "crowdinContext": "Text of a button to confirm creation of a saved search"
  },
  "TOAST_SEARCH_CREATE_SUCCESS": {
    "text": "Søket er lagret!",
    "crowdinContext": "Toast message if saved search was successfully created"
  },
  "TOAST_SEARCH_CREATE_ERROR": {
    "text": "En feil oppstod under lagring av søk. Prøv igjen senere.",
    "crowdinContext": "Toast message if an error occurred while creating saved search"
  },
  "SETTINGS_CHANNEL_NAME_WEB": {
    "text": "FINN.no",
    "crowdinContext": "Name of the channel for web notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_WEB": {
    "text": "Nye treff varsles umiddelbart under «Varslinger» på nettsiden og i appen",
    "crowdinContext": "Description of the setting for Web notifications"
  },
  "SETTINGS_CHANNEL_NAME_PUSH": {
    "text": "Push",
    "crowdinContext": "Name of the channel for push notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_PUSH": {
    "text": "Nye treff varsles umiddelbart på mobil",
    "crowdinContext": "Description of the setting for Push notifications"
  },
  "SETTINGS_CHANNEL_NAME_EMAIL": {
    "text": "E-post",
    "crowdinContext": "Name of the channel for email notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_EMAIL": {
    "text": "Nye treff sendes daglig på e-post",
    "crowdinContext": "Description of the setting for Email notifications"
  },
  "SETTING_CHANNEL_TOGGLE_ARIA_LABEL": {
    "text": "Vippebryter",
    "crowdinContext": "Aria label for notification toggle switch"
  },
  "NAME_INPUT_MAX_LENGTH_HELP_TEXT": {
    "text": "Maks 50 tegn",
    "crowdinContext": "Name input help text informing about max length"
  },
  "NAME_INPUT_EMPTY_HELP_TEXT": {
    "text": "Du må gi søket et navn",
    "crowdinContext": "Name input help text informing about not leaving the name empty"
  },
  "DELETE_SEARCH_MODAL_TITLE": {
    "text": "Er du sikker at du vil slette",
    "crowdinContext": "Delete saved search modal header title"
  },
  "DELETE_SEARCH_MODAL_DESCRIPTION": {
    "text": "Både varslinger og lagret søk vil bli slettet for altid.",
    "crowdinContext": "Description informing user about deleting both saved search and its notification settings"
  },
  "DELETE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Slett søket",
    "crowdinContext": "Text of a button to confirm deletion of a saved search"
  },
  "TOAST_SEARCH_DELETE_ERROR": {
    "text": "Søket ble ikke slettet, prøv igjen om litt!",
    "crowdinContext": "Toast message if an error occurred while deleting saved search"
  },
  "TOAST_SEARCH_DELETE_SUCCESS": {
    "text": "Søket er slettet",
    "crowdinContext": "Toast message if settings was successfully deleted"
  },
  "TOAST_SEARCH_UPDATE_SUCCESS": {
    "text": "Endringene er lagret",
    "crowdinContext": "Toast message if settings was successfully updated"
  },
  "CANCEL_BUTTON_TEXT": {
    "text": "Avbryt",
    "crowdinContext": "Cancel button text"
  },
  "RENAME_MODAL_NAME_INPUT_LABEL": {
    "text": "Navn på søket",
    "crowdinContext": "Label of the name edit input for rename modal"
  },
  "RENAME_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Endre navnet",
    "crowdinContext": "Text of a button to confirm rename of a saved search"
  },
  "TOAST_SEARCH_RENAME_ERROR": {
    "text": "Navn endringen ble ikke lagret, prøv igjen om litt!",
    "crowdinContext": "Toast message if an error occurred while renaming saved search"
  },
  "TOAST_SEARCH_NOTIFICATION_EDIT_ERROR": {
    "text": "Endringen ble ikke lagret",
    "crowdinContext": "Toast message if an error occurred while editing saved search notification"
  },
  "EDIT_MODAL_RENAME_BUTTON_TEXT": {
    "text": "Endre navn på søket",
    "crowdinContext": "Edit modal rename button text"
  },
  "EDIT_MODAL_FOOTER_DELETE_BUTTON_TEXT": {
    "text": "Slett søket",
    "crowdinContext": "Button text opening the saved search deletion modal"
  },
  "LOADING_MODAL_TEXT": {
    "text": "Gi oss noen sekund så skal vi få hentet innstillingene dine",
    "crowdinContext": "Text displayed when loading re-fetched saved search"
  },
  "ERROR_MODAL_TITLE": {
    "text": "Oisann",
    "crowdinContext": "Error modal title displayed when saved search fails to load"
  },
  "ERROR_MODAL_INFO_RETRY_TEXT": {
    "text": "Vi klarte ikke å hente innstillingene dine, la oss prøve en gang til.",
    "crowdinContext": "Error modal information about failing to load a saved search and possibility to try again"
  },
  "ERROR_MODAL_RETRY_BUTTON_TEXT": {
    "text": "Prøv igjen",
    "crowdinContext": "Error modal retry button text"
  },
  "ERROR_MODAL_IMAGE_ALT_TEXT": {
    "text": "Feil ved innlasting av søket",
    "crowdinContext": "Alt text for image displayed when loading the search fails"
  }
}